import { Box, Grid, LinearProgress, Typography } from '@mui/material';
import TableCard from 'lib/designSystem/Card/TableCard';
import React from 'react';

type BankReconciliationSummaryCardsProps = {
  reconciliationPercentages: {
    reconciled: number;
    unreconciled: number;
  };
  reconciliationAmounts: {
    reconciled: number;
    unreconciled: number;
  };
  balances: {
    initial: number;
    period: number;
    total: number;
  };
  formatAmount: (value?: number) => string;
};

const BankReconciliationSummaryCards: React.FC<
  BankReconciliationSummaryCardsProps
> = ({
  reconciliationPercentages,
  reconciliationAmounts,
  balances,
  formatAmount,
}) => (
  <Grid container spacing={2} sx={{ mb: 2 }}>
    <Grid item xs={12} md={6}>
      <TableCard sx={{ p: 2 }} enabledEffects={false}>
        <Typography
          variant="h6"
          color="text.secondary"
          fontWeight={700}
          sx={{ mb: 1 }}
        >
          Porcentaje de conciliación
        </Typography>
        <Box sx={{ mb: 2 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              mb: 0.75,
            }}
          >
            <Box>
              <Typography variant="body2" color="text.secondary">
                {`Conciliado: ${reconciliationPercentages.reconciled}%`}
              </Typography>
              <Typography variant="subtitle2" fontWeight={700}>
                {formatAmount(reconciliationAmounts.reconciled)}
              </Typography>
            </Box>
            <Box sx={{ textAlign: 'right' }}>
              <Typography variant="body2" color="text.secondary">
                {`No conciliado: ${reconciliationPercentages.unreconciled}%`}
              </Typography>
              <Typography variant="subtitle2" fontWeight={700}>
                {formatAmount(reconciliationAmounts.unreconciled)}
              </Typography>
            </Box>
          </Box>
          <LinearProgress
            variant="determinate"
            value={reconciliationPercentages.reconciled}
            sx={{
              height: 8,
              borderRadius: 999,
            }}
          />
        </Box>
      </TableCard>
    </Grid>
    <Grid item xs={12} md={6}>
      <TableCard sx={{ p: 2 }} enabledEffects={false}>
        <Typography
          variant="h6"
          color="text.secondary"
          fontWeight={700}
          sx={{ mb: 1 }}
        >
          Saldos
        </Typography>
        <Grid container spacing={1}>
          <Grid item xs={12} md={4}>
            <Typography variant="body2" color="text.secondary">
              Saldo inicial
            </Typography>
            <Typography variant="h6" fontWeight={700}>
              {formatAmount(balances.initial)}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="body2" color="text.secondary">
              Saldo período
            </Typography>
            <Typography variant="h6" fontWeight={700}>
              {formatAmount(balances.period)}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="body2" color="text.secondary">
              Saldo final
            </Typography>
            <Typography variant="h6" fontWeight={700}>
              {formatAmount(balances.total)}
            </Typography>
          </Grid>
        </Grid>
      </TableCard>
    </Grid>
  </Grid>
);

export default BankReconciliationSummaryCards;
